/** Spanish catalog. Move names & Pokémon species stay English. */
export default {
  'deposit.title': 'Depósito',
  'deposit.eyebrow': 'Centro Pokémon',
  'deposit.sub': 'Guarda objetos y mueve Pokémon entre el equipo y el Box.',
  'deposit.close': 'Cerrar depósito',
  'deposit.items': 'Objetos',
  'deposit.pokemon': 'Pokémon',
  'deposit.searchItem': 'Buscar objeto...',
  'deposit.itemCategory': 'Filtrar categoría de objeto',
  'deposit.allCategories': 'Todas las categorías',
  'deposit.balls': 'Poké Balls',
  'deposit.potions': 'Pociones',
  'deposit.stones': 'Piedras',
  'deposit.loot': 'Botín',
  'deposit.backpack': 'Mochila',
  'deposit.storage': 'Depósito',
  'deposit.storeAll': 'Guardar todo',
  'deposit.searchPokemon': 'Buscar Pokémon...',
  'deposit.filterShiny': 'Solo Shiny',
  'deposit.from': 'desde',
  'deposit.to': 'hasta',
  'deposit.level': 'Nivel',
  'deposit.team': 'Equipo',
  'deposit.box': 'Box',
  'deposit.pokemonHint': 'Mueve Pokémon entre el equipo y el Box. Tu compañero principal permanece equipado.',
  'deposit.open': 'Depósito',
  'deposit.openAria': 'Abrir el depósito del Centro Pokémon',
  'deposit.resultsOf': '{filtered} de {total} Pokémon en el Box',
  'deposit.noTeam': 'Ningún Pokémon equipado.',
  'deposit.pokemonCount': '{count} Pokémon',
  'deposit.itemCount': '{count} objetos guardados',
  'deposit.mainPartner': 'El compañero principal no puede depositarse',
  'deposit.moveToBox': 'Mover al Box',
  'deposit.moveToTeam': 'Mover al equipo',
  'deposit.emptyBackpack': 'Ningún objeto de la mochila coincide con los filtros.',
  'deposit.emptyStorage': 'Nada en el depósito coincide con los filtros.',
  'deposit.withdrawItem': 'Retirar objeto',
  'deposit.storeItem': 'Guardar objeto',
  'deposit.serverItemsDisabled': 'Con inventario en el servidor, el depósito de objetos está desactivado (usa la mochila).',
  'deposit.category.BALL': 'Poké Ball',
  'deposit.category.POTION': 'Poción',
  'deposit.category.STONE': 'Piedra',
  'deposit.category.LOOT': 'Botín',
  'nav.main': 'Navegación principal',
  'nav.city': 'Ciudad',
  'nav.hunt': 'Cacería',
  'nav.captures': 'Capturas',
  'nav.automation': 'Automatización',
  'nav.inventory': 'Inventario',
  'nav.pokedex': 'Pokédex',
  'nav.market': 'Mercado',
  'nav.emeraldStore': 'Tienda de Esmeraldas',
  'nav.gamePass': 'Game Pass',
  'nav.dailyGift': 'Daily Gift',
  'nav.specialization': 'Especialización',
  'nav.myPokemon': 'Mis Pokémon',
  'nav.collection': 'Colección',
  'nav.map': 'Mapa',
  'nav.altar': 'Altar',
  'nav.breeding': 'Cría',
  'nav.atlas': 'Atlas de Caza',
  'nav.systems': 'Sistemas',
  'nav.compare': 'Comparar Pokémon',
  'compare.eyebrow': 'Laboratorio de batalla',
  'compare.title': 'Comparar Pokémon',
  'compare.sub': 'Compara especies simuladas o tus Pokémon, proyectando nivel y evolución sin cambiar tu colección.',
  'compare.close': 'Cerrar comparación',
  'compare.left': 'Pokémon 1',
  'compare.right': 'Pokémon 2',
  'compare.swap': 'Intercambiar Pokémon',
  'compare.modeLabel': 'Fuente de la comparativa',
  'compare.modeSpecies': 'Simular especie',
  'compare.modeOwned': 'Mis Pokémon',
  'compare.search': 'Buscar Pokémon...',
  'compare.searchOwned': 'Buscar tus Pokémon...',
  'compare.noOwned': 'Todavía no tienes Pokémon para comparar.',
  'compare.pick': 'Busca un Pokémon para empezar.',
  'compare.rarity': 'Rareza',
  'compare.quality': 'Calidad (IV)',
  'compare.results': 'Comparativa',
  'compare.needBoth': 'Elige los dos Pokémon para ver la comparativa.',
  'compare.power': 'Power',
  'compare.tie': 'Empate',
  'compare.powerLead': '{percent}% más de Power',
  'compare.wins': '{name} gana',
  'compare.ownedBadge': 'Tu Pokémon',
  'compare.originalLevel': 'Nivel actual',
  'compare.simulatedLevel': 'Nivel simulado',
  'compare.evolution': 'Evolución simulada',
  'compare.evolutionRequirement': 'Nv. {level}',
  'compare.shiny': 'Shiny',
  'compare.band.regular': 'Regular',
  'compare.band.promissor': 'Prometedor',
  'compare.band.elite': 'Élite',
  'compare.band.perfeito': 'Perfecto',
  'compare.note': 'En modo especie, la simulación usa el multiplicador nominal de la rareza e IV distribuidos por igual. En modo Mis Pokémon, los datos reales solo se usan en la vista previa; nada aquí cambia tu colección.',
  'altar.eyebrow': 'Camino garantizado',
  'altar.title': 'Altar Shiny',
  'altar.intro': 'Gasta Shiny Cards genéricas para invocar una batalla shiny garantizada de una especie que ya viste.',
  'altar.steps': '1) Reúne 50 cartas · 2) elige una especie vista · 3) invoca una ventana de encuentros shiny garantizados.',
  'altar.cards': 'Shiny Cards',
  'altar.cardsOwned': '{count} cartas',
  'altar.cost': 'Costo: {cost}',
  'altar.pickSpecies': 'Elige una especie',
  'altar.search': 'Buscar especie...',
  'altar.invoke': 'Invocar shiny',
  'altar.needCards': 'Shiny Cards insuficientes.',
  'altar.needSpecies': 'Selecciona una especie ya vista.',
  'altar.invoked': '¡Shiny de {name} invocado!',
  'altar.close': 'Cerrar altar',
  'shiny.wildAppeared': '✦ ¡Apareció un shiny {name}!',
  'shiny.captured': '✦ ¡Shiny {name} capturado!',
  'shiny.cardDrop': '+{count} Shiny Card(s)',
  'shiny.guaranteed': 'Encuentro shiny garantizado',
  'breeding.eyebrow': 'Centro de Cría',
  'breeding.title': 'Cría',
  'breeding.intro': 'Dos padres se convierten en un huevo — herencia de IV, calidad que sube generación a generación, y la caza del linaje perfecto.',
  'breeding.pair': 'Par reproductor',
  'breeding.slot': 'Espacio {n}',
  'breeding.pickFromBox': 'Elige en la caja',
  'breeding.clearSlot': 'Quitar del espacio',
  'breeding.parentsConsumed': 'Los 2 padres se CONSUMEN al crear el huevo. Calidad del hijo = mejor padre + Δ.',
  'breeding.analysis': 'Análisis de cría',
  'breeding.mysteryChild': 'Hijo misterioso',
  'breeding.emptyAnalysis': 'Elige 2 padres en la caja para revelar el análisis de compatibilidad y el rango de calidad.',
  'breeding.step1Title': 'Elige 2 padres',
  'breeding.step1Text': 'Misma especie, directo de tu caja',
  'breeding.step2Title': 'Paga el costo',
  'breeding.step2Text': 'Monedas, piedras del elemento y feromonas',
  'breeding.step3Title': 'Eclosiona cazando',
  'breeding.step3Text': 'Las derrotas en caza incuban el huevo',
  'breeding.needPair': 'Elige 2 padres',
  'breeding.needPairToast': 'Selecciona dos Pokémon de la misma especie.',
  'breeding.incompatible': 'Par incompatible',
  'breeding.incompatibleHint': 'Ambos padres deben ser de la misma especie.',
  'breeding.compat': 'Compatibilidad',
  'breeding.ivInherit': 'Herencia de IV',
  'breeding.qualityProjected': 'Calidad proyectada',
  'breeding.bestParent': 'Mejor padre: Q {q}',
  'breeding.cap': 'techo {cap}',
  'breeding.deltaChances': 'Probabilidades de Δ (suma al mejor padre)',
  'breeding.ivCopyNote': 'El IV copia al padre de mayor Calidad',
  'breeding.ivCopyBonus': '·+15%',
  'breeding.modePheromones': 'Feromonas',
  'breeding.modePheromonesHint': 'Δ completo (+0.15 a +0.30)',
  'breeding.modeFree': 'Gratis',
  'breeding.modeFreeHint': 'Δ ~20× menor · ~20% menos de costo',
  'breeding.hatchInfo': 'Eclosiona con hasta {count} derrotas en caza',
  'breeding.doubleStones': 'Doblar piedras',
  'breeding.doubleStonesHint': '+15% herencia · 5% de +1 en el IV',
  'breeding.youHave': 'tienes {count}',
  'breeding.costLacking': 'Costo insuficiente',
  'breeding.createEgg': 'Crear huevo',
  'breeding.eggCreated': '¡Huevo creado y colocado en la incubadora!',
  'breeding.incubator': 'Incubadora',
  'breeding.incubatorFull': 'Incubadora llena',
  'breeding.incubatorFullToast': 'Incubadora llena (2 espacios).',
  'breeding.slotFree': 'Espacio libre',
  'breeding.noEggs': 'Ningún huevo incubando.',
  'breeding.eggProgress': '{current} / {needed} derrotas',
  'breeding.eggReady': '¡Listo para eclosionar!',
  'breeding.hatched': '¡{name} eclosionó!',
  'breeding.activeBonuses': 'Bonos activos',
  'breeding.bonusPheromonesText': '+0.15 a +0.30 de calidad en el hijo',
  'breeding.bonusFreeText': 'Δ ~20× menor · costo ~20% menor',
  'breeding.bonusDouble': 'Piedras dobles',
  'breeding.bonusDoubleText': '+15% herencia · 5% de +1 en el IV',
  'breeding.box': 'Tus Pokémon (caja)',
  'breeding.searchPlaceholder': 'Buscar por nombre...',
  'breeding.sortIv': 'Mayor IV',
  'breeding.sortQuality': 'Mayor Q',
  'breeding.sortLevel': 'Mayor Nv.',
  'breeding.sortName': 'Nombre A–Z',
  'breeding.emptyBox': 'Ningún Pokémon disponible en la caja.',
  'breeding.close': 'Cerrar cría',
  'breeding.notEnoughCoins': 'Oro insuficiente.',
  'breeding.notEnoughStones': 'Piedras insuficientes.',
  'breeding.notEnoughPheromones': 'Feromonas insuficientes.',
  'atlas.eyebrow': 'Cacerías',
  'atlas.title': 'Atlas de Hunt',
  'atlas.intro': 'Elige tipo, franja de nivel y la especie específica que quieres cazar.',
  'atlas.pickType': 'Tipo',
  'atlas.pickLevel': 'Nivel',
  'atlas.pickSpecies': 'Especie',
  'atlas.search': 'Buscar especie...',
  'atlas.difficulty': 'Dificultad',
  'atlas.seen': 'Vista',
  'atlas.caught': 'Capturada',
  'atlas.notCaught': 'No capturada',
  'atlas.speciesCount': '{count} especies',
  'atlas.levelLabel': 'Nivel de caza',
  'atlas.unlockRequirement': 'Requisito de desbloqueo',
  'atlas.unlockHint': 'Sigue subiendo el nivel de tu Entrenador para desbloquear esta caza.',
  'atlas.unseen': '???',
  'atlas.startHunt': 'Cazar {name} · Nv.{level}',
  'atlas.startFailed': 'No se pudo iniciar la hunt. Abre la consola (F12) e inténtalo de nuevo.',
  'atlas.needPartner': 'Equipa un Pokémon compañero antes de cazar.',
  'atlas.bossTag': 'Jefe',
  'atlas.zoneTag': 'Zona',
  'atlas.zoneLevelLabel': 'Rango de zona',
  'atlas.species': 'Pool',
  'atlas.pickZone': 'Zona',
  'atlas.zoneTitle': 'Zona {type} · Nv.{level}',
  'atlas.zoneIntro': 'Manadas de una sola especie en las esquinas. Un mini-jefe puede invocar refuerzos — usa habilidad de área.',
  'atlas.zoneIntroShort': 'En el endgame enfrentas biomas completos con reglas, pools y legendarios propios.',
  'atlas.zoneAoeHint': 'Recomendado: MT / habilidad de área en tu Pokémon.',
  'atlas.zoneAoeWarn': 'Zona densa: equipa una habilidad de área (MT) para limpiar las manadas.',
  'atlas.startZone': 'Entrar en {type} · {level}',
  'atlas.back': 'Volver',
  'atlas.close': 'Cerrar atlas',
  'atlas.empty': 'Ninguna especie en esta franja.',
  'atlas.legacyMode': 'Modo legado tipo×franja',
  'hunt.speciesFocus': 'Foco: {name}',
  'hunt.mapTransition': '{name} salió de las ruinas — la caza entra en el desierto.',
  'hunt.mapTransitionLog': '{name} cruzó la pirámide y llegó al desierto.',
  'hunt.zoneFocus': '{type} · {level}',
  'team.aoeSlot': 'Habilidad de área',
  'team.aoeLocked': 'Se libera en Nv.{level}',
  'team.aoeEmpty': 'Ninguna MT equipada',
  'team.equipTm': 'Equipar MT',
  'team.unequipAoe': 'Quitar AoE',
  'team.tmOwned': '{count} MT(s)',
  'team.tmApplied': 'MT aplicada: {move}',
  'team.noTm': 'No tienes MTs.',
  'boss.label': 'JEFE',
  'boss.adds': '+{count} aliados',
  'battle.multiTargets': '{count} objetivos',
  'zone.apex': 'Ápex',
  'zone.threatTier': 'Amenaza {tier}',
  'zone.recommendedPower': 'Power recomendado',
  'zone.powerValue': 'Power recomendado: {power}',
  'zone.nextBoss': 'Próximo legendario',
  'zone.rewardBonus': 'Bono de XP',
  'zone.bossProgress': 'Rastro legendario',
  'zone.effectsSummary': '+{xp}% XP · +{loot}% drops · +{damage}% daño enemigo',
  'zone.legendaryRotation': 'Rotación legendaria',
  'zone.legendaryGuideTitle': 'Cómo aparece el legendario',
  'zone.legendaryGuide': 'Derrota a {count} Pokémon en esta zona para completar el Rastro Legendario. El próximo encuentro especial será {name}; al derrotarlo o capturarlo, el rastro se reinicia y la rotación avanza.',
  'zone.legendaryBoss': 'LEGENDARIO',
  'zone.mythicalBoss': 'MÍTICO',
  'zone.hourlyFeatured': 'Destacado de la hora',
  'zone.hourlyFocusTitle': 'Encuentro especial (GMT-3)',
  'zone.hourlyFocusGuide': 'Chance rara (~1 en {n} derrotas) del {kind} destacado: {name}. Sin garantía. Una bola por KO — se recomienda Master/Apex.',
  'zone.rotationCountdown': 'Cambia en {time}',
  'zone.specialOdds': '~1/{n} derrotas',
  'zone.specialPool': 'Pool de la hora',
  'zone.noSpecial': '—',
  'zone.noSpecialTitle': 'Sin rotación especial',
  'zone.noSpecialHint': 'Esta zona tiene packs y mini-jefes del bioma, sin legendario/mítico horario.',
  'zone.captureHint': 'Ultra ~1% en el endgame. Master Ball asegura; Apex Ball ~25% en especiales.',
  'zone.specialAppearedLog': '¡{name} apareció en {zone} (destacado de la hora)!',
  'zone.specialAppearedToast': '¡{name} apareció! Destacado de la hora.',
  'zone.enter': 'Entrar en la zona',
  'zone.requirement.trainerLevel': 'Entrenador Nv.{value}',
  'zone.requirement.mastery': 'Maestría {value}',
  'zone.requirement.prestige': 'Prestigio {value}',
  'zone.bossReadyLog': 'El rastro en {zone} está completo. El legendario apareció.',
  'zone.bossReadyToast': '¡Jefe legendario desbloqueado!',
  'zone.bossDefeated': '{name} fue derrotado en {zone}.',
  'zone.bossDefeatedToast': '¡{name} derrotado!',
  'zones.supreme-threshold.title': 'Frontera Suprema',
  'zones.supreme-threshold.description': 'Campeones de varios biomas prueban tu equipo antes de las amenazas mayores.',
  'zones.ashen-spire.title': 'Aguja de Ceniza',
  'zones.ashen-spire.description': 'El calor extremo fortalece atacantes y vuelve cada asalto más peligroso.',
  'zones.obsidian-court.title': 'Corte de Obsidiana',
  'zones.obsidian-court.description': 'Una fortaleza de acero y piedra para combates largos contra grandes defensas.',
  'zones.eclipse-rift.title': 'Grieta del Eclipse',
  'zones.eclipse-rift.description': 'Sombras y energía psíquica: pool de legendarios con destacado cada hora (GMT-3).',
  'zones.final-horizon.title': 'Horizonte Final',
  'zones.final-horizon.description': 'El reto máximo: pool de míticos con foco horario y las capturas más duras del endgame.',

  'items.apexball.name': 'Apex Ball',
  'items.apexball.desc': '~25% de captura en especiales de zona (Amenaza 3/4).',
  'shop.emeraldBalls': 'Bolas premium',
  'shop.vipMasterGift': 'Activar VIP otorga 1 Master Ball.',

  'profile.trainer': 'Entrenador',
  'profile.level': 'Nivel',
  'profile.title': 'Perfil',
  'profile.sub': 'Identidad, progreso y atajos del entrenador.',
  'profile.general': 'Información general',
  'profile.progression': 'Progresión',
  'profile.captureLog': 'Registro de capturas',
  'profile.customizeOutfit': 'Personalizar outfit',
  'profile.saveOutfit': 'Guardar outfit',
  'profile.outfitEyebrow': 'Apariencia',
  'profile.outfitTitle': 'Personalizar outfit',
  'profile.openPrestige': 'Entrenador y Prestigio',
  'profile.since': 'desde el inicio',
  'profile.coins': 'Oro',
  'profile.defeated': 'Derrotas',
  'profile.captured': 'Capturas',
  'profile.pokedex': 'Pokédex',
  'profile.prestige': 'Prestigio',
  'profile.peakLevel': 'Nivel máximo',
  'profile.talents': 'Puntos de especialización',
  'profile.outfitSaved': '¡Outfit actualizado!',
  'profile.xpLine': '{current} / {max} XP',
  'profile.xpReady': 'Listo para Prestigio',
  'profile.pokedexProgress': '{owned}/{total}',
  'profile.footer': 'IdleMon — Perfil de {name}',

  'settings.open': 'Ajustes',
  'settings.title': 'Ajustes',
  'settings.language': 'Idioma',
  'settings.language.en': 'English',
  'settings.language.pt-BR': 'Português (BR)',
  'settings.language.es': 'Español',
  'settings.close': 'Cerrar ajustes',

  'common.close': 'Cerrar',
  'common.new': 'Nuevo',
  'confirm.eyebrow': 'Confirmación',
  'confirm.title': 'Confirmar acción',
  'common.you': 'Tú',
  'common.lv': 'Nv.',
  'common.coins': 'IdleCoin',
  'common.active': 'ACTIVO',
  'common.buy': 'Comprar',
  'common.sell': 'Vender',
  'common.selectAll': 'Seleccionar todo',
  'common.evolve': 'Evolucionar',
  'common.status': 'Estado',
  'common.power': 'Poder',
  'common.emptySlot': 'Espacio vacío',
  'common.learned': 'APRENDIDO',
  'common.area': 'Área',

  'battle.searching': 'BUSCANDO POKÉMON',
  'battle.searchingNext': 'BUSCANDO EL SIGUIENTE',
  'battle.paused': 'VIAJE EN PAUSA',
  'battle.walking': 'Caminando automáticamente',
  'battle.seekingTarget': '{name} está buscando un objetivo',
  'battle.yourPokemon': '{name} · Tu Pokémon',
  'battle.sound': 'Activar/desactivar sonido',
  'battle.routeLabel': 'RUTA {type} · NIVEL {min}–{max}',
  'battle.defeatedTitle': '¡{name} derrotado!',
  'battle.cannotAttack': '¡{name} no puede atacar!',
  'battle.combat': 'Combate',
  'battle.expTrainer': 'EXP Entrenador',
  'battle.expPokemon': 'EXP Pokémon',
  'battle.total': 'total',
  'battle.levelUp': '¡{name} subió al Nv. {level}!',
  'levelup.eyebrow': '¡LEVEL UP!',
  'levelup.text': '¡Subiste de nivel!',
  'battle.drops': 'Objetos',

  'team.heading': 'MI EQUIPO',
  'team.equipped': 'Pokémon equipados',
  'team.aria': 'Mi equipo',
  'team.manageTitle': 'Mis Pokémon',
  'team.manageEyebrow': 'Equipo activo',
  'team.manageHint': 'Gestiona estadísticas, evolución y movimientos de tus seis Pokémon equipados.',
  'team.close': 'Cerrar Mis Pokémon',
  'team.noPartner': 'Elige a tu primer compañero antes de gestionar el equipo.',
  'team.movesDiscarded': 'Los cambios de movimientos no aplicados se descartaron.',
  'team.movesApplied': '¡Movimientos de {name} aplicados!',
  'team.evolveTo': 'Evolucionar a {name}',
  'team.noMoves': 'No hay movimientos disponibles en este nivel.',
  'team.applyMoves': 'Aplicar movimientos',

  'hunt.last': 'Última cacería',
  'hunt.analyzer': 'Hunt Analyzer',
  'hunt.sub': 'Tasas de la sesión, botín y balance de la última cacería.',
  'hunt.close': 'Cerrar Hunt Analyzer',
  'hunt.lastRoute': 'ÚLTIMA RUTA COMPLETADA',
  'hunt.none': 'Ninguna cacería registrada',
  'hunt.completeHint': 'Completa un viaje para ver el resumen.',
  'hunt.time': 'Tiempo de cacería',
  'hunt.defeated': 'Derrotados',
  'hunt.captured': 'Capturados',
  'hunt.xp': 'EXP obtenida',
  'hunt.currentSession': 'SESIÓN ACTUAL',
  'hunt.loot': 'Loot',
  'hunt.supply': 'Supply',
  'hunt.itemsCount': '{count} objetos',
  'hunt.supplyDetail': '{balls} balls · {potions} pociones',
  'hunt.balance': 'Balance (Loot + Capturas − Supply)',
  'hunt.sessionDrops': 'Drops de la sesión',
  'hunt.noDrops': 'Aún no cayó ningún objeto.',
  'hunt.rateHint': 'Tasas basadas en los últimos 10 minutos de cacería',
  'hunt.grossRate': 'Ingreso bruto / hora',
  'hunt.supplyRate': 'Consumo / hora',
  'hunt.netRate': 'Balance neto / hora',
  'hunt.economyHealthy': 'La cacería es sostenible en esta muestra',
  'hunt.economyWarning': 'El consumo supera los ingresos — ajusta ruta/equipo',

  'capture.title': 'Registro de Capturas',
  'capture.eyebrow': 'Registro de capturas · últimas 100',
  'capture.sub': 'Capturas recientes con rareza, IV y brillo shiny.',
  'capture.close': 'Cerrar registro de capturas',
  'capture.total': 'Total:',
  'capture.normals': 'Normales:',
  'capture.filterAll': 'Todos',
  'capture.filterNormal': 'Normal',
  'capture.foot': '✨ Las capturas Shiny se destacan. El historial se actualiza automáticamente.',
  'capture.empty': 'No se encontraron capturas para este filtro.',
  'capture.ivUnavailable': 'Los IV detallados no están disponibles para esta captura.',
  'capture.panelTitle': 'Captura',
  'capture.ready': '{count} listos',
  'capture.throw': 'Lanzar',
  'capture.caught': 'Capturado',
  'capture.escaped': 'Se liberó',
  'capture.chance': '{pct}%',
  'capture.noBall': 'Sin balls',
  'capture.autoCaught': '¡Capturado!',
  'capture.autoEscaped': 'Se liberó',
  'capture.capReached': 'Límite diario de capturas alcanzado',
  'capture.shinyCapReached': 'Límite diario de capturas shiny alcanzado',
  'capture.highIvCapReached': 'Límite diario de capturas de IV alto alcanzado',
  'capture.autoChance': '{pct}% de probabilidad',
  'capture.vipSkip': 'Omitido (filtro VIP)',

  'auto.eyebrow': 'Automatización',
  'auto.title': 'Auto-Helper',
  'auto.sub': 'Define cómo tu compañero usa los objetos de tu mochila.',
  'auto.close': 'Cerrar automatización',
  'auto.capture': 'Captura automática',
  'auto.captureHint': 'Intentar capturar tras ganar',
  'auto.captureNormalHint': 'Capturar Pokémon normales tras ganar',
  'auto.captureVip': 'Función VIP — suscríbete para capturar automáticamente tras ganar.',
  'auto.ball': 'Poké Ball usada',
  'auto.ballNone': 'No hay Poké Balls en el inventario.',
  'auto.potion': 'Poción automática',
  'auto.potionHint': 'Curar automáticamente con HP bajo',
  'auto.potionWhen': 'Usar poción cuando HP ≤',
  'auto.potionUsed': 'Poción usada',
  'auto.revive': 'Auto-revivir',
  'auto.reviveHint': 'Usar un Revive cuando tu compañero se debilite',
  'auto.reviveUsed': 'Revive usado',
  'auto.reviveStock': '{count} Revive(s) disponible(s)',
  'auto.reviveNone': 'No hay Revives en el inventario.',
  'auto.shiny': 'Capturar Shiny automáticamente',
  'auto.shinyHint': 'Usar una Ball exclusiva para Pokémon Shiny',
  'auto.shinyBall': 'Poké Ball para Shiny',
  'auto.vip': 'Captura selectiva',
  'auto.vipHint': 'Capturar solo los Pokémon que elijas en esta ruta.',
  'auto.vipNote': '✦ Disponible con suscripción VIP',
  'auto.speciesOnRoute': '{count} especies en esta ruta',
  'auto.pickAny': 'Selecciona cualquier combinación',
  'auto.emptyPool': 'No hay encuentros configurados en esta ruta.',

  'inv.eyebrow': 'Mochila del entrenador',
  'inv.title': 'Inventario',
  'inv.sub': 'Balls, pociones, drops y suministros.',
  'inv.close': 'Cerrar inventario',
  'inv.items': 'Objetos:',
  'inv.drops': 'Drops:',
  'inv.dropsValue': '{value} IdleCoin',
  'inv.foot': 'Los drops se pueden vender en la tienda de la ciudad. Las pociones y balls también aparecen en Automatización.',
  'inv.empty': 'Mochila vacía.',
  'inv.section.balls': 'Poké Balls',
  'inv.section.potions': 'Pociones',
  'inv.section.stones': 'Piedras de evolución',
  'inv.section.drops': 'Drops',

  'dex.eyebrow': 'Especies con sprites Myst',
  'dex.title': 'Pokédex',
  'dex.sub': 'Explora especies, estadísticas, evoluciones y precios de venta.',
  'dex.close': 'Cerrar Pokédex',
  'dex.search': 'Buscar nombre o #...',
  'dex.allTypes': 'Todos los tipos',
  'dex.ownedOnly': 'Solo capturados',
  'dex.seen': 'Vistos:',
  'dex.caught': 'Capturados:',
  'dex.emptyDetail': 'Selecciona un Pokémon para ver estadísticas, evoluciones y precio de venta.',
  'dex.filterType': 'Filtrar por tipo',
  'dex.locations': 'Dónde aparece',
  'dex.atlasFocus': 'Objetivo del Atlas',
  'dex.fishing': 'Pesca',
  'dex.noLocations': 'No aparece en las rutas salvajes actuales (fuera del pool de hunt).',
  'dex.capture': 'Captura',
  'dex.catchInfo': 'Dificultad base de la especie: {label} · tasa base {rate} · el nivel y la bola definen la probabilidad real en combate.',
  'dex.baseStats': 'Stats base',
  'dex.stat.hp': 'HP',
  'dex.stat.atk': 'ATQ',
  'dex.stat.def': 'DEF',
  'dex.stat.spa': 'At.Esp',
  'dex.stat.spd': 'Def.Esp',
  'dex.stat.spe': 'VEL',
  'dex.evoLine': 'Línea evolutiva',
  'dex.baseForm': 'base',
  'dex.sellSection': 'Venta',
  'dex.sellNote': 'Transferencia estimada de un ejemplar común Nv.1/IV50: {price} IdleCoin. El valor sube con nivel, IV y calidad.',
  'dex.notOwned': 'Aún no tienes este Pokémon. Captura uno para poder venderlo.',
  'dex.noneFound': 'No se encontró ningún Pokémon.',
  'dex.legendary': 'LEGENDARIO',

  'col.eyebrow': 'Pokédex personal',
  'col.title': 'Tu colección',
  'col.close': 'Cerrar colección',
  'col.hint': 'Rareza e IV en la lista · haz clic para detalles',
  'col.search': 'Buscar por nombre...',
  'col.filterType': 'Filtrar por tipo',
  'col.filterRarity': 'Filtrar por rareza',
  'col.ivMode': 'Modo de filtro de IV',
  'col.ivMin': 'IV mín.',
  'col.ivMax': 'IV máx.',
  'col.ivValue': 'IV total de 0 a 186',
  'col.clear': 'Limpiar filtros',
  'col.allTypes': 'Todos los tipos',
  'col.allRarities': 'Todas las rarezas',
  'col.results': '{count} Pokémon',

  'city.safeZone': 'Zona segura · Multijugador',
  'city.walkHint': 'Usa W A S D para caminar · mapa original',
  'city.floor': 'Piso 7',
  'city.teleport': 'Atajo de ciudad',
  'city.teleportHint': 'Ir a la tienda',
  'city.teleportTitle': 'Destinos de la ciudad',
  'city.teleportAria': 'Teletransportar a la tienda',
  'city.teleportMenuAria': 'Destinos de teletransporte de la ciudad',
  'city.teleportDestinations': '{count} destinos disponibles',
  'city.arrivedNpc': 'Llegaste hasta {name}.',
  'city.store': 'Tienda',
  'city.storeAria': 'Ir a la tienda',
  'city.healTeam': 'Curar equipo',
  'city.openShop': 'Abrir tienda',
  'city.openTmShop': 'Ver drops de MT',
  'city.fisherName': 'Finn',
  'city.startFishing': 'Empezar a pescar',
  'city.mapAlt': 'Saffron City del mapa original de Poketibia',
  'city.roofsAlt': 'Techos de Saffron City',
  'city.pcRoofAlt': 'Techo del Pokémon Center',
  'city.shopRoofAlt': 'Techo de la tienda',
  'city.trainerAlt': 'Tu entrenador',
  'city.partnerAlt': 'Tu Pokémon principal',
  'city.routeMapAlt': 'Mapa original de rutas',
  'city.arrivedShop': 'Llegaste a la tienda.',
  'city.welcome': '¡Bienvenido a Saffron City, entrenador!',
  'city.marketSoon': 'Mercado de intercambios próximamente.',
  'city.soundSoon': 'El sonido se añadirá con los efectos de batalla.',

  'fish.eyebrow': 'Muelle de Saffron',
  'fish.title': 'Pesca',
  'fish.sub': 'Elige lugar, cebo y caña, luego lanza. Las especies acuáticas solo salen aquí.',
  'fish.hint': 'Los Pokémon acuáticos se capturan aquí. La caña define el techo; no sube tu nivel ni elige la franja por ti.',
  'fish.statusEyebrow': 'Estado',
  'fish.spotEyebrow': 'Lugar',
  'fish.baitEyebrow': 'Cebo',
  'fish.rodEyebrow': 'Caña',
  'fish.idle': 'Listo para lanzar.',
  'fish.casting': 'Línea en el agua…',
  'fish.start': 'Empezar a pescar',
  'fish.stop': 'Dejar de pescar',
  'fish.started': 'Pesca iniciada.',
  'fish.stopped': 'Pesca detenida.',
  'fish.needRod': 'Compra una caña en la tienda.',
  'fish.busyHunt': 'Termina la cacería antes de pescar.',
  'fish.bandHint': 'Pesca Nv.{min}–{max} · franja elegida: Nv.{selected} · {rod}',
  'fish.rodRange': 'Hasta Nv.{max}',
  'fish.rodEffect': 'Alcance hasta Nv.{max} · no sube tu nivel',
  'fish.caught': '¡Capturaste a {name} Nv.{level}!',
  'fish.escaped': '{name} escapó.',
  'fish.noBall': 'Sin Poké Balls — pesca en pausa.',
  'fish.noBaitStock': 'Sin cebo — pesca en pausa.',
  'fish.nibble': 'Un tirón… nada esta vez.',
  'fish.xpLabel': 'Pesca Nv.{level} · XP {xp}',
  'fish.spotLocked': 'Requiere pesca Nv.{level}',
  'fish.spotReady': 'Abierto',
  'fish.noBait': 'Sin cebo',
  'fish.baitNoneHint': 'Velocidad base de lance',
  'fish.spot.pier': 'Muelle',
  'fish.spot.deepSea': 'Mar profundo',
  'fish.bait.common': 'Cebo común',
  'fish.bait.elite': 'Cebo élite',
  'fish.mat.fins': 'Aletas',
  'fish.mat.water-pendant': 'Colgante de agua',
  'fish.mat.pearl': 'Perla',
  'fish.mat.dome-fossil': 'Fósil Domo',
  'fish.mat.helix-fossil': 'Fósil Helix',
  'fish.mat.old-amber': 'Ámbar Viejo',
  'systems.hubTitle': 'Sistemas de la ciudad',
  'systems.hubSub': 'Economía · retención · premium · combate',
  'raid.title': 'World Raid',
  'raid.hubSub': 'Jefe mundial',
  'raid.hubNew': 'Nuevo jefe',
  'raid.hubHp': '{pct}% derrotado',
  'raid.hubDefeated': 'Derrotado — ¡reclama!',
  'raid.hubExpired': 'Ventana cerrada',
  'raid.hint': 'Caza con normalidad: cada derrota en la hunt aporta daño al jefe. No hay botón de spam: el progreso viene de cazar.',
  'raid.yourContrib': 'Tu contribución: {value}',
  'raid.damagePct': '{pct}% del HP ya quitado',
  'raid.statusActive': 'Activo · termina en {time}',
  'raid.statusDefeated': '¡Jefe derrotado! Reclama tu recompensa.',
  'raid.statusExpired': 'Ventana cerrada. Reclama según tu contribución.',
  'raid.statusClaimed': 'Recompensa ya reclamada. Hay un jefe nuevo.',
  'raid.claim': 'Reclamar recompensa',
  'raid.claimed': 'Ya reclamado',
  'raid.claimHintReady': 'Listo para reclamar: el botín escala con tu contribución.',
  'raid.claimHintDone': 'Ya reclamaste en esta raid.',
  'raid.claimHintNoDmg': 'Caza wilds para aportar daño antes de reclamar.',
  'raid.claimHintActive': 'El jefe sigue en pie. Sigue cazando hasta que el HP llegue a 0 (o termine la ventana).',
  'raid.claimHintWait': 'Espera a que termine la raid para reclamar.',
  'raid.claimOk': 'Botín: {loot}',
  'raid.timeHours': '{hours}h {mins}m',
  'raid.timeMins': '{mins}m',
  'raid.err.raid_still_active': 'El jefe sigue activo: sigue cazando.',
  'raid.err.already_claimed': 'Ya reclamaste en esta raid.',
  'raid.err.no_contribution': 'Sin contribución: caza wilds primero.',
  'raid.err.invalid_raid': 'Raid inválida.',
  'raid.err.generic': 'No se pudo reclamar.',
  'npc.shop': 'Tienda',
  'npc.tmShop': 'Tienda de MT',
  'npc.nurse': 'Nurse Joy',
  'npc.blacksmith': 'Herrero',
  'npc.apothecary': 'Boticario',
  'npc.miner': 'Minero',
  'npc.fisher': 'Pescador',
  'npc.professor': 'Profesor',
  'npc.questBoard': 'Tablón de misiones',
  'npc.gymLeader': 'Líder de gimnasio',
  'npc.clanHerald': 'Casa del clan',
  'npc.auctioneer': 'Subastador',

  'chat.aria': 'Chat global',
  'chat.world': 'Mundo',
  'chat.trade': 'Intercambio',
  'chat.help': 'Ayuda',
  'chat.online': 'En línea',
  'chat.placeholder': 'Hablar en Mundo...',
  'chat.send': 'Enviar',
  'chat.placeholder.world': 'Hablar en Mundo...',
  'chat.placeholder.trade': 'Hablar en Intercambio...',
  'chat.placeholder.help': 'Pedir ayuda...',
  'chat.loading': 'Cargando mensajes...',
  'chat.empty': 'Todavía no hay mensajes en este canal.',
  'chat.systemCapture': '¡{trainer} capturó {name} ({tag})!',
  'chat.error': 'No se pudo actualizar el chat.',
  'chat.muted': 'Estás silenciado y no puedes enviar mensajes ahora.',
  'chat.slowDown': 'Estás enviando mensajes demasiado rápido.',
  'chat.blockedLanguage': 'Tu mensaje contiene lenguaje que no está permitido en el chat.',
  'chat.invalidAttachment': 'Este objeto o Pokémon no se puede enlazar.',
  'chat.attachmentLimit': 'Puedes enlazar hasta {count} assets por mensaje.',
  'chat.alreadyLinked': 'Este asset ya está enlazado.',
  'chat.linked': '{name} fue enlazado al chat.',
  'chat.removeAttachment': 'Quitar enlace',
  'chat.shiftToLink': 'Shift + clic para enlazar en el chat',
  'chat.quantity': 'Cantidad',
  'chat.moves': 'Movimientos',
  'chat.equipped': 'Equipado',
  'chat.partner': 'Compañero',
  'chat.verified': 'Custodia verificada',
  'chat.verifiedHint': 'Asset verificado en el inventario del servidor al enviar el mensaje.',
  'chat.localSnapshot': 'Captura del guardado local publicada por este jugador.',
  'chat.previewOnly': 'El envío está desactivado en la vista previa.',
  'chat.previewWelcome': '¡Bienvenido al chat de IdleMon!',
  'chat.previewTrade': 'Miren este Pokémon que equipé.',
  'chat.previewHelp': 'Pasa el cursor sobre el enlace para ver sus detalles.',
  'admin.open': 'Admin',
  'inv.pokemon': 'Pokémon:',
  'inv.section.pokemon': 'POKÉMON · SHIFT + CLIC PARA ENLAZAR',

  'map.eyebrow': 'Explora el mundo',
  'map.title': 'Mapa de rutas',
  'map.levelBand': 'RANGO DE NIVEL',
  'map.close': 'Cerrar mapa',
  'map.youAreHere': 'ESTÁS AQUÍ',
  'map.region': 'REGIÓN',
  'map.bossesSoon': 'Próximamente',
  'map.bossesTitle': 'Zonas AoE',
  'map.bossesZones': 'Endgame',
  'map.bossesHint': 'Las arenas y los Pokémon legendarios de Myst aparecerán aquí. Por ahora, explora las rutas por rango de nivel.',
  'map.bossesHintActive': 'Elige el nivel de zona y el tipo. Manadas mono-especie en las esquinas; mini-jefes invocan refuerzos.',
  'map.legendCity': 'Ciudad',
  'map.legendRoute': 'Ruta disponible',
  'map.legendPick': 'Selecciona una ruta para viajar',
  'map.route': 'Ruta {type} · {levels}',
  'map.speciesChance': '{count} especies · probabilidad por encuentro',
  'map.preview': 'Vista previa · {hint}',
  'map.lockBand': 'El rango se desbloquea en el Nv. {level}',
  'map.lockLevel': '{type} se desbloquea en el Nv. {level}',
  'map.lockHint': '{type} solo aparece a partir del Nv. {level}.',
  'map.travelLog': 'Viajaste a la ruta de tipo {type}.',
  'map.arriving': 'Llegando al territorio {type}...',
  'map.bosses': 'Zonas',
  'map.routes': 'Rutas',

  'dialog.pcEyebrow': 'Pokémon Center',
  'dialog.pcText': '¡Bienvenido al Pokémon Center! Puedo restaurar por completo a tu equipo gratis.',
  'dialog.healAll': 'Curar a todos los Pokémon',
  'dialog.healedLog': 'Todo el equipo fue curado en el Pokémon Center.',
  'dialog.healedToast': '¡Tu equipo está totalmente recuperado!',
  'dialog.faintedLog': '{name} se debilitó y fue llevado al Pokémon Center. El equipo fue curado.',
  'dialog.faintedToast': '¡Tu Pokémon fue llevado al Pokémon Center y está recuperado!',
  'dialog.shopTitle': 'Tienda de Sam',
  'dialog.shopEyebrow': 'Tienda de la ciudad',
  'dialog.shopSub': 'Compra suministros, vende drops y Pokémon de sobra.',
  'dialog.tmShopTitle': 'MT de Sammy',
  'dialog.tmShopIntro': 'Las MT no se venden. Las 18 pueden caer en encuentros regulares de zonas avanzadas, con mayor peso para el tipo de la zona. Cada disco se consume al enseñar y solo puede usarse en un Pokémon de Nv. 100 o superior.',
  'dialog.tmDropOnly': 'Las 18 MT se obtienen únicamente como drops de encuentros en zonas avanzadas.',
  'dialog.tmDropOnlyShort': 'Drop de zona avanzada',
  'dialog.dropOnlyItem': 'Este objeto solo se puede obtener como drop de una zona avanzada.',
  'dialog.tmEffect': 'Movimiento de área de {type} · requiere Pokémon Nv.{level}',
  'dialog.closeShop': 'Cerrar tienda',
  'dialog.qty': 'Cantidad',
  'dialog.ivFrom': 'de',
  'dialog.ivTo': 'a',
  'dialog.ivMin': 'IV mín. (0–186)',
  'dialog.ivMax': 'IV máx. (0–186)',
  'dialog.buy': 'Comprar',
  'dialog.sell': 'Vender',
  'dialog.sellTotal': 'Total ({count})',
  'dialog.pokemon': 'Pokémon',
  'dialog.noDrops': 'Aún no hay drops para vender.',
  'dialog.noPokemonFilter': 'Ningún Pokémon coincide con los filtros.',
  'dialog.pickItem': 'Selecciona al menos un objeto.',
  'dialog.pickPokemon': 'Selecciona al menos un Pokémon.',
  'dialog.bought': 'Compraste {qty}× {name}.',
  'dialog.soldDrops': '¡Vendido por {total} IdleCoin!',
  'dialog.soldPokemon': '¡Vendiste {count} Pokémon por {total} IdleCoin!',
  'dialog.noCoins': 'IdleCoin insuficiente.',
  'dialog.inStock': 'posee {qty}',
  'dialog.stockLine': '{qty}× en stock · {total}',
  'dialog.onTeam': 'en el equipo',
  'dialog.lockSale': 'Bloquear venta',
  'dialog.unlockSale': 'Desbloquear venta',

  'evo.eyebrow': 'Evolución disponible',
  'evo.title': 'Evolucionar Pokémon',
  'evo.sub': 'Elige cómo evolucionar. Los IV y la rareza siempre se conservan.',
  'evo.fromAlt': 'Forma actual',
  'evo.toAlt': 'Siguiente evolución',
  'evo.warning': 'En una evolución normal, el Pokémon vuelve al nivel 1. Los IV y la rareza se conservan.',
  'evo.normal': 'Evolucionar y volver al nivel 1',
  'evo.coins': 'Mantener nivel con IdleCoin',
  'evo.coinCost': '{cost} IdleCoin para mantener el nivel {level}',
  'evo.notEnoughCoins': 'No tienes suficiente IdleCoin para esta evolución.',
  'evo.canEvolve': '¡{name} puede evolucionar!',
  'evo.toast': '¡{from} evolucionó a {to}!',
  'common.yes': 'Sí',
  'common.no': 'No',
  'mastery.leveled': '¡{name} alcanzó Maestría {level}!',
  'capture.hpChance': '{hp}% PS · {pct}% de probabilidad',
  'battle.initiative': 'Iniciativa',
  'battle.captureWindow': 'Ventana de captura',
  'progress.eyebrow': 'Progresión avanzada',
  'progress.title': 'Entrenador y Prestigio',
  'progress.sub': 'Bonos de cuenta, camino de XP y reinicio de Prestigio.',
  'progress.perksEyebrow': 'Bonos de cuenta',
  'progress.prestige': 'Dar prestigio al entrenador',
  'progress.prestigeShort': 'Prestigio {count}',
  'progress.ready': 'Listo para Prestigio',
  'progress.xp': '{current} / {max} XP',
  'progress.offlineTraining': 'Entrenamiento sin conexión',
  'progress.reserveVip': 'Reserva (VIP)',
  'progress.loot': 'Botín extra',
  'progress.capture': 'Bono de captura',
  'progress.xpBonus': 'Bono total de XP',
  'progress.offlineCap': 'Límite offline',
  'progress.mastery': 'Maestría desbloqueada',
  'progress.note': 'El Prestigio reinicia el nivel actual, pero mantiene rutas y Maestría. Cada Prestigio otorga 2% de XP, 1 hora offline, 1 punto de Especialización y 1 reinicio gratis.',
  'progress.maxPrestige': 'Prestigio máximo alcanzado',
  'progress.requires300': 'Requiere nivel 300 de entrenador',
  'progress.confirm': '¿Dar Prestigio ahora? Tu entrenador vuelve al nivel 1, pero conserva las rutas y la Maestría.',
  'progress.completed': '¡Prestigio de entrenador {count} alcanzado!',
  'progress.openSpecialization': 'Abrir Especialización',
  'specialization.close': 'Cerrar Especialización',
  'specialization.eyebrow': 'Streak Points',
  'specialization.title': 'Streak Points',
  'specialization.intro': 'Invierte puntos de talento y registra derrotas. Los hitos de nivel y el Prestigio otorgan puntos; la Veteranía sube cada 1.000 derrotas.',
  'specialization.statsEyebrow': 'Resumen',
  'specialization.investEyebrow': 'Invertir',
  'specialization.available': 'puntos disponibles',
  'specialization.allocated': 'puntos distribuidos',
  'specialization.prestigeCount': 'rango de Prestigio',
  'specialization.stat.totalKills': 'Derrotas totales',
  'specialization.stat.available': 'Puntos disponibles',
  'specialization.stat.used': 'Puntos usados',
  'specialization.stat.nextPoint': 'Próximo hito en',
'specialization.streakNote': '1 Streak Point cada 1.000 derrotas · los puntos invertibles vienen de hitos de derrotas',
  'specialization.streak.exp': 'EXP',
  'specialization.streak.loot': 'LOOT',
  'specialization.streak.catch': 'CATCH',
  'specialization.streak.shiny': 'SHINY',
  'specialization.streakValuePct': '+{value}%',
  'specialization.streakValueReserve': '{value}% reserva',
  'specialization.streakPer.exp': '+{value} p.p. de XP de reserva por punto',
  'specialization.streakPer.loot': '+{value}% de loot por punto',
  'specialization.streakPer.catch': '+{value}% de captura por punto',
  'specialization.streakPer.shiny': '+{value}% de progreso Shiny por punto',
  'specialization.pointsInPath': '{count} punto(s)',
  'specialization.investPlus': '+ Invertir',
  'specialization.killsEyebrow': 'Historial',
  'specialization.killsTitle': 'Derrotas por Pokémon',
  'specialization.killsEmpty': 'Aún no hay derrotas registradas. Derrota wilds en las cacerías para llenar esta cuadrícula.',
  'specialization.killEyebrow': 'Veteranía de combate',
  'specialization.killBonus': '+{value}% de XP por derrotas',
  'specialization.killMax': 'Bono máximo alcanzado con {kills} enemigos derrotados.',
  'specialization.killNext': '{kills} derrotas. Faltan {remaining} para el hito de {next}.',
  'specialization.shinyEyebrow': 'Investigación Shiny',
  'specialization.shinyTitle': 'La misma regla para todas las especies',
  'specialization.shinyRule': 'Cada especie acumula sus propias derrotas. El soft pity comienza en {start} y crece hasta el tope, sin Shiny garantizado.',
  'specialization.shinyBase': 'probabilidad base',
  'specialization.shinyPity': 'inicio del soft pity',
  'specialization.shinyCapLabel': 'tope de probabilidad',
  'specialization.shinyResearchBonus': 'Investigador actual: +{value}% de progreso por derrota',
  'specialization.path': 'Camino',
  'specialization.next': 'Siguiente',
  'specialization.maxRank': 'Rango máximo',
  'specialization.maxed': 'Completo',
  'specialization.invest': 'Invertir 1 punto',
  'specialization.trainer.name': 'Mentor',
  'specialization.trainer.description': 'Tu compañero equipado sigue entrenando mientras el juego está cerrado.',
  'specialization.hunter.name': 'Cazador',
  'specialization.hunter.description': 'Mejora la cantidad de materiales obtenidos en las cacerías.',
  'specialization.catcher.name': 'Capturador',
  'specialization.catcher.description': 'Aumenta la probabilidad final de cada intento de captura.',
  'specialization.researcher.name': 'Investigador',
  'specialization.researcher.description': 'Acelera la investigación Shiny específica de cada especie.',
  'specialization.effect.trainer': 'El compañero entrena sin conexión al {offline}% del ritmo',
  'specialization.effect.hunter': '+{value}% de botín',
  'specialization.effect.catcher': '+{value}% de captura',
  'specialization.effect.researcher': '+{value}% de progreso Shiny',
  'specialization.respecFree': 'Reiniciar gratis ({count})',
  'specialization.respecCost': 'Reiniciar por {cost} IdleCoin',
  'specialization.systemsEyebrow': '¿Dónde están los otros sistemas?',
  'specialization.systemsTitle': 'Sistemas activos de progresión',
  'specialization.system.prestige': 'Prestigio',
  'specialization.system.prestigeWhere': 'Perfil del entrenador · después del nivel 300',
  'specialization.system.mastery': 'Maestría',
  'specialization.system.masteryWhere': 'Mis Pokémon · niveles superiores a 300',
  'specialization.system.evolution': 'Evolución',
  'specialization.system.evolutionWhere': 'Mis Pokémon · al alcanzar el nivel requerido',
  'specialization.system.offline': 'Caza offline',
  'specialization.system.offlineWhere': 'Automatización · requiere muestra activa de 5 min',
  'specialization.system.research': 'Investigación, calidad y drops',
  'specialization.system.researchWhere': 'Pokédex · detalle de cada especie',
  'specialization.system.combat': 'Speed e iniciativa',
  'specialization.system.combatWhere': 'Cacería · relojes independientes por combatiente',
  'specialization.confirmInvest': '¿Invertir en {name}? El próximo efecto será: {effect}.',
  'specialization.invested': '{name} avanzó al rango {rank}.',
  'specialization.noPointsServer': 'El servidor aún no registró un Streak Point disponible. Espera a que se sincronice la cacería e inténtalo de nuevo.',
  'specialization.notEnoughCoins': 'No hay suficiente IdleCoin para reiniciar la Especialización.',
  'specialization.confirmRespecFree': '¿Reiniciar todos los puntos usando un reinicio gratis?',
  'specialization.confirmRespecCost': '¿Reiniciar todos los puntos por {cost} IdleCoin?',
  'specialization.respecced': 'Puntos de Especialización reiniciados.',
  'specialization.killMilestoneLog': '{kills} enemigos derrotados: el bono permanente de XP llegó a +{value}%.',
  'specialization.killMilestoneToast': 'Veteranía: ¡+{value}% de XP permanente!',
  'offline.title': 'Caza offline',
  'offline.hint': 'Descansa en la caza para armar el rendimiento offline',
  'offline.requirement': 'Requiere 5 minutos de caza activa para formar una muestra.',
  'offline.start': 'Iniciar caza offline',
  'offline.rest': 'Descansar',
  'offline.restHint': 'Detiene la caza y arma las recompensas offline. Sin esto, cerrar el juego no paga nada.',
  'offline.restReady': 'Caza activa: pulsa Descansar para armar el offline y cerrar el juego.',
  'offline.restIdle': 'Entra en una caza y pulsa Descansar para armar el offline. Cerrar sin descansar no paga.',
  'offline.restNeedHunt': 'Empieza una caza antes de descansar.',
  'offline.restArmed': 'Offline armado. Puedes cerrar el juego — vuelve después para cobrar.',
  'offline.restArmedRisk': 'Offline armado sin pociones/revive: la muestra para pronto si cae tu compañero.',
  'offline.restArmFailed': 'No se pudo armar el offline. Inténtalo de nuevo.',
  'offline.faintedNoSupplies': 'Tu compañero cayó sin poción/revive. La muestra de la caza se detuvo.',
  'offline.pending': 'Las recompensas están listas para recoger.',
  'offline.active': 'La caza offline está activa. Regresa más tarde para recogerla.',
  'offline.ready': 'Muestra lista: {time} de caza activa.',
  'offline.sampling': 'Muestreando la caza: {time} / 05:00.',
  'offline.notReady': 'Caza al menos 5 minutos antes de ir offline.',
  'offline.started': 'Caza offline iniciada. Límite actual: {hours}h.',
  'offline.reportEyebrow': 'Informe offline',
  'offline.reportTitle': 'La caza continuó',
  'offline.claim': 'Recoger recompensas',
  'offline.time': 'tiempo offline',
  'offline.efficiency': 'Las recompensas usan el 50% de la muestra de combate de los últimos 10 minutos. Las capturas, piedras y tiradas raras están desactivadas offline.',
  'offline.noDrops': 'No se generaron botines estables en este período.',
  'offline.claimed': '¡Recompensas offline recogidas!',
  'offline.serverEfficiency': '¡Bienvenido de vuelta! Tu hunt siguió rindiendo mientras no estabas, al {pct} de tu ritmo de farmeo. Las capturas ocurren mientras juegas.',
  'offline.trainerXp': 'XP del entrenador',
  'offline.pokemonXp': 'XP del compañero',
  'offline.pokemonShare': 'Tu compañero entrenó sin conexión al {pct}% del ritmo, gracias a Mentor/VIP.',
  'offline.pokemonLocked': 'Tu compañero no entrena sin conexión. Invierte en Mentor (Especialización) o activa el VIP para desbloquear hasta el 75% de la XP.',
  'offline.reserveShare': 'El resto de tu equipo equipado también entrenó: +{xp} XP cada uno (VIP).',
  'offline.reserveNone': 'Ningún Pokémon de la reserva recibió XP en este período.',
  'offline.reserveVipOnly': 'La reserva solo entrena offline con VIP (10% de la XP del compañero).',
  'offline.stopLabel': 'Paró porque',
  'offline.stop.rest': 'descansaste a propósito',
  'offline.stop.rest_at_risk': 'descansaste sin pociones/revive',
  'offline.stop.supplies_exhausted': 'se acabaron las pociones/revive — la muestra offline paró pronto',
  'offline.stop.fainted_no_supplies': 'tu compañero cayó sin poción/revive',
  'offline.gotIt': 'Entendido',
  'offline.serverDisabled': 'Offline desactivado con progreso en el servidor (evita XP/botín fantasma).',
  'dex.captureDifficulty': 'Dificultad',
  'dex.possibleDrops': 'Drops posibles',
  'dex.dropHint': 'Cada objeto tiene chance independiente por derrota, con rango de cantidad.',
  'dex.drop.primaryRole': 'Drop principal',
  'dex.drop.secondaryRole': 'Drop secundario',
  'dex.drop.signatureRole': 'Drop especial',
  'dex.drop.stoneRole': 'Piedra de evolución',
  'dex.drop.lootRole': 'Loot',
  'dex.noDrops': 'Esta especie no tiene drops configurados.',

  'auth.eyebrow': 'CUENTA DE ENTRENADOR',
  'auth.title': 'Entra en el mundo de IdleMon',
  'auth.intro': 'Tu cuenta protege tu identidad y prepara tu acceso al Mercado Global.',
  'auth.registerTab': 'Crear cuenta',
  'auth.loginTab': 'Entrar',
  'auth.email': 'Correo electrónico',
  'auth.emailPlaceholder': 'tu@ejemplo.com',
  'auth.loginIdentifier': 'Correo electrónico o nombre de usuario',
  'auth.loginIdentifierPlaceholder': 'tu@ejemplo.com o TuEntrenador',
  'auth.trainerName': 'Nombre de usuario',
  'auth.trainerNamePlaceholder': 'TuEntrenador',
  'auth.trainerNameHint': '3–16 caracteres: letras, números o _',
  'auth.password': 'Contraseña',
  'auth.passwordPlaceholder': 'Mínimo 8 caracteres',
  'auth.passwordConfirmation': 'Confirmar contraseña',
  'auth.passwordConfirmationPlaceholder': 'Repite la contraseña',
  'auth.passwordLoginPlaceholder': 'Tu contraseña',
  'auth.rulesAcceptPrefix': 'He leído y acepto las',
  'auth.rulesLink': 'Reglas del Juego',
  'auth.version': 'versión',
  'auth.create': 'Crear mi cuenta',
  'auth.login': 'Entrar al juego',
  'auth.forgotPassword': 'Olvidé mi contraseña',
  'auth.resetIntro': 'Introduce el correo de tu cuenta para recibir un enlace seguro de recuperación.',
  'auth.sendReset': 'Enviar enlace de recuperación',
  'auth.backToLogin': 'Volver a iniciar sesión',
  'auth.newPasswordIntro': 'Crea una nueva contraseña para recuperar tu cuenta.',
  'auth.newPassword': 'Nueva contraseña',
  'auth.saveNewPassword': 'Guardar nueva contraseña',
  'auth.sendingReset': 'Enviando enlace de recuperación…',
  'auth.resetSent': 'Si el correo está registrado, el enlace de recuperación llegará en breve.',
  'auth.savingPassword': 'Guardando tu nueva contraseña…',
  'auth.passwordUpdated': 'Contraseña actualizada. Entra de nuevo con tu nueva contraseña.',
  'auth.recoveryReady': 'Enlace validado. Elige tu nueva contraseña.',
  'auth.betaNote': 'Entorno beta: el progreso todavía se guarda en este navegador.',
  'auth.rulesClose': 'Cerrar reglas',
  'auth.rulesEyebrow': 'REGLAS DEL JUEGO',
  'auth.rulesTitle': 'Reglas preliminares de la beta',
  'auth.rulesDraftNote': 'Este texto es preliminar. Las reglas definitivas se publicarán antes de la beta abierta y tendrán una nueva versión para aceptar.',
  'auth.rulesDraftVersion': 'Versión preliminar {version}',
  'auth.rulesVersion': 'Versión {version}',
  'auth.account': 'Cuenta',
  'auth.signOut': 'Cerrar sesión',
  'auth.creating': 'Creando tu cuenta…',
  'auth.entering': 'Entrando…',
  'auth.loading': 'Comprobando tu sesión…',
  'auth.verifyingEmail': 'Confirmando tu cuenta…',
  'auth.verifyingRecovery': 'Validando tu enlace de recuperación…',
  'auth.confirmationSent': 'Cuenta creada, pero aún no está activa. Enviamos un enlace a {email}. Abre el correo y confirma tu cuenta antes de entrar.',
  'auth.emailPendingActivation': 'Esta cuenta ya fue creada, pero aún no está activada. Enviamos un nuevo enlace a {email}. Abre el correo y confirma tu cuenta antes de entrar.',
  'auth.emailConfirmed': '¡Cuenta confirmada con éxito! Ahora solo inicia sesión.',
  'auth.errorNameUnavailable': 'Ese nombre de usuario ya está en uso o está reservado.',
  'auth.errorNameInvalid': 'Usa de 3 a 16 letras, números o _ en tu nombre de usuario.',
  'auth.errorRules': 'Debes leer y aceptar las Reglas del Juego.',
  'auth.errorEmailExists': 'Este correo ya tiene una cuenta activa. Entra con tu correo y contraseña o usa “Olvidé mi contraseña”.',
  'auth.errorEmailRate': 'Demasiados intentos de envío de correo. Espera unos minutos e inténtalo de nuevo.',
  'auth.errorCredentials': 'Correo electrónico, nombre de usuario o contraseña incorrectos.',
  'auth.errorLoginRate': 'Demasiados intentos de inicio de sesión. Espera unos minutos e inténtalo de nuevo.',
  'auth.errorEmailUnconfirmed': 'Tu cuenta aún no está activada. Abre el enlace de confirmación que enviamos a tu correo antes de entrar.',
  'auth.errorLinkExpired': 'Este enlace de confirmación caducó o ya se usó. Vuelve a “Crear cuenta”, regístrate con el mismo correo y te enviaremos uno nuevo.',
  'auth.errorRecoveryExpired': 'Este enlace de recuperación caducó o ya se usó. Pide otro en “Olvidé mi contraseña”.',
  'auth.errorProfileMissing': 'Entraste, pero no encontramos tu perfil de entrenador. Recarga la página; si continúa, avisa al soporte.',
  'auth.errorUserBanned': 'Esta cuenta está suspendida. Contacta al soporte para más detalles.',
  'auth.errorSignupDisabled': 'La creación de cuentas está cerrada temporalmente. Inténtalo más tarde.',
  'auth.errorSamePassword': 'La nueva contraseña debe ser distinta de la anterior.',
  'auth.errorCaptcha': 'Completa la verificación de seguridad e inténtalo de nuevo.',
  'auth.errorNetwork': 'No se pudo contactar con el servidor. Revisa tu conexión.',
  'auth.errorGeneric': 'No se pudo completar la operación. Inténtalo de nuevo.',
  'auth.errorIpLimit': 'Ya se crearon demasiadas cuentas desde tu red (misma IP). Por seguridad, espera 24 horas e inténtalo de nuevo.',
  'auth.errorServerInternal': 'El servidor encontró un error al procesar tu cuenta. Inténtalo de nuevo; si persiste, avisa al soporte.',
  'auth.errorEmailSend': 'No se pudo enviar el correo de confirmación a esa dirección. Inténtalo de nuevo en unos minutos; si persiste, avisa al soporte.',
  'auth.errorPasswordWeak': 'Esa contraseña apareció en filtraciones de datos y es fácil de adivinar. Elige otra distinta, mezclando letras, números y símbolos.',
  'auth.checkingName': 'Comprobando disponibilidad…',
  'auth.nameAvailable': '¡Nombre de usuario disponible!',
  'auth.errorEmail': 'Introduce un correo válido.',
  'auth.errorPassword': 'La contraseña debe tener al menos 8 caracteres.',
  'auth.errorPasswordMatch': 'Las contraseñas no coinciden.',
  'auth.errorBackend': 'El servicio de cuentas aún no está disponible. Inténtalo de nuevo en breve.',
  'auth.sessionSuperseded': 'Tu cuenta inició sesión en otro dispositivo. Esta sesión se cerró.',
  'auth.sessionRequired': 'Sesión inválida. Vuelve a entrar.',
  'auth.sessionConflictEyebrow': 'SESIÓN ACTIVA ENCONTRADA',
  'auth.sessionConflictTitle': 'Tu cuenta ya está abierta en otro navegador',
  'auth.sessionConflictBody': 'Para proteger tu progreso, solo un navegador puede jugar con esta cuenta a la vez.',
  'auth.sessionConflictNote': 'Puedes asumir el control en este navegador o mantener la sesión que ya está abierta. Ninguna opción mantiene dos partidas activas.',
  'auth.sessionConflictKeep': 'Mantener sesión existente',
  'auth.sessionConflictTakeover': 'Jugar en este navegador',
  'auth.sessionConflict': 'Hay otra sesión activa. Elige qué navegador debe continuar.',
  'auth.sessionConflictKept': 'Se mantuvo la sesión existente. Este navegador se desconectó.',
  'auth.sessionConflictChanged': 'La sesión activa cambió mientras decidías. Elige de nuevo.',

  'starter.eyebrow': 'Tu viaje comienza ahora',
  'starter.title': 'Elige tu Pokémon inicial',
  'starter.hint': 'Será el líder de tu equipo en las hunts. Los demás llegarán con la captura.',
  'starter.step1Title': 'Elige tu entrenador',
  'starter.step1Hint': 'Elige la apariencia y pinta cada pieza de ropa.',
  'starter.step2Title': 'Elige tu Pokémon inicial',
  'starter.step2Hint': 'Será el líder de tu equipo en las hunts. Los demás llegarán con la captura.',
  'starter.step3Title': 'Elige tu Pokémon inicial',
  'starter.step3Hint': 'Será el líder de tu equipo en las hunts. Los demás llegarán con la captura.',
  'starter.save': 'Tu progreso se guarda en este navegador.',
  'starter.picked': '¡{name} ahora es tu compañero!',
  'starter.chosen': '✓ Elegido',
  'starter.regionTitle': 'Elige una región',
  'starter.region.kanto': 'Kanto',
  'starter.region.johto': 'Johto',
  'starter.region.hoenn': 'Hoenn',
  'starter.region.sinnoh': 'Sinnoh',
  'starter.trainerTitle': 'Elige tu entrenador',
  'starter.lookTitle': 'Elige un aspecto',
  'starter.colorsTitle': 'Colores de ropa',
  'starter.colorsHint': 'Cada ranura pinta una región de tela de este aspecto. La piel del personaje no cambia.',
  'starter.color.head': 'Pelo / accesorio',
  'starter.color.body': 'Ropa principal',
  'starter.color.legs': 'Ropa secundaria',
  'starter.color.feet': 'Detalle / calzado',
  'starter.boy': 'Chico',
  'starter.girl': 'Chica',
  'starter.nameLabel': 'Nombre del entrenador',
  'starter.namePlaceholder': 'Tu nombre',
  'starter.next': 'Siguiente',
  'starter.back': 'Volver',
  'starter.start': 'Empezar el viaje',
  'starter.needStarter': 'Elige un Pokémon inicial.',
  'starter.needLook': 'Elige una apariencia.',
  'starter.needName': 'Escribe un nombre (2–16 caracteres).',
  'starter.grassPoison': 'PLANTA · VENENO',
  'starter.fire': 'FUEGO',
  'starter.water': 'AGUA',
  'starter.initialMove': 'Movimiento inicial',

  'looks.trainer': 'Entrenador',
  'looks.elite': 'Elite',
  'looks.adventurer': 'Aventurero',
  'looks.atletic': 'Atlético',
  'looks.punk': 'Punk',
  'looks.mercenary': 'Mercenario',
  'looks.catcher': 'Capturador',
  'looks.rapper': 'Rapper',
  'looks.jamaican': 'Jamaicano',
  'looks.oriental': 'Oriental',
  'looks.rocket': 'Rocket',
  'looks.business': 'Ejecutivo',
  'looks.fisher': 'Pescador',
  'looks.hiker': 'Excursionista',
  'looks.police': 'Policía',
  'looks.veteran': 'Veterano',
  'looks.psychic': 'Psíquico',

  'log.ready': 'El viaje está listo para comenzar.',
  'log.leveled': '{name} alcanzó el nivel {level}.',
  'log.trainerLeveled': 'Alcanzaste el nivel {level}.',
  'log.learned': 'aprendió {move}.',
  'log.lootReceived': 'Botín recibido: {items}',
  'log.learnedToast': '¡{name} aprendió {move}!',
  'log.defeatedXp': 'derrotado · +{xp} EXP',
  'log.defeatedDrop': 'derrotado · +{xp} EXP · drop: {drops}',
  'log.defeatedRare': 'derrotado · +{xp} EXP · 💎 drop raro: {drops}',
  'log.rareToast': '💎 ¡Raro! ¡{name} soltó {item}!',
  'log.notVip': '{name} no está en el filtro VIP.',
  'log.noBall': 'No tienes {ball} disponible.',
  'log.noBallToast': 'No hay {ball} en el inventario.',
  'log.escaped': '{name} se liberó de la {ball} ({chance}% · {difficulty}).',
  'log.noEncounter': '{name} salió de la cola del servidor — captura cancelada (sin gastar bola).',
  'log.noEncounterToast': 'El encuentro aún se sincroniza. Prueba de nuevo en un momento.',
  'log.ghostRestored': '{count} captura(s) rara(s) recuperada(s) del historial.',
  'log.captured': '¡capturado en el nivel {level}! {rarity} · IV {iv}',
  'log.capturedToast': '¡{name} capturado en el nivel {level} · {rarity}!',
  'log.potionUsed': '{name} usó {item} (+{hp} HP).',
  'log.reviveUsed': '¡{name} volvió con un Revive!',
  'log.sold': 'vendido · +{total} IdleCoin',
  'log.partnerSeeking': '{name} · Tu Pokémon',

  'toast.pickPotion': 'Selecciona una poción disponible en el panel de poción automática.',
  'toast.potionUsed': '¡{name} usada!',
  'toast.emptyPotion': 'No hay pociones en el inventario. Compra algunas en la tienda.',
  'toast.revived': '¡Revive usado — la caza continúa!',

  'types.elétrico': 'Eléctrico',
  'types.fogo': 'Fuego',
  'types.água': 'Agua',
  'types.planta': 'Planta',
  'types.inseto': 'Bicho',
  'types.voador': 'Volador',
  'types.normal': 'Normal',
  'types.psíquico': 'Psíquico',
  'types.pedra': 'Roca',
  'types.terra': 'Tierra',
  'types.fantasma': 'Fantasma',
  'types.dragão': 'Dragón',
  'types.lutador': 'Lucha',
  'types.veneno': 'Veneno',
  'types.sombrio': 'Siniestro',
  'types.aço': 'Acero',
  'types.gelo': 'Hielo',
  'types.fada': 'Hada',

  'rarities.Comum': 'Común',
  'rarities.Incomum': 'Poco común',
  'rarities.Raro': 'Raro',
  'rarities.Épico': 'Épico',
  'rarities.Lendário': 'Legendario',
  'rarities.Mítico': 'Mítico',
  'rarities.Celestial': 'Celestial',
  'rarities.Ancião': 'Anciano',
  'rarities.Secreto': 'Secreto',
  'rarities.Inicial': 'Inicial',

  'catch.easy': 'Fácil',
  'catch.medium': 'Medio',
  'catch.hard': 'Difícil',
  'catch.veryHard': 'Muy difícil',

  'maps.saffron-meadows': 'Praderas de Saffron',
  'maps.viridian-trail': 'Sendero de Viridian',
  'maps.pewter-forest': 'Bosques de Pewter',
  'maps.pewter-woods': 'Arboledas de Pewter',
  'maps.rock-tunnel-swamp': 'Pantanos del Rock Tunnel',
  'maps.rock-tunnel-caves': 'Cuevas del Rock Tunnel',
  'maps.cinnabar-volcano': 'Volcán de Cinnabar',
  'maps.cinnabar-ashes': 'Cenizas de Cinnabar',
  'maps.sevii-islands': 'Islas Legendarias',
  'maps.glacial-sea': 'Mar Glacial',
  'maps.supreme-threshold': 'Umbral Supremo',
  'maps.ashen-spire': 'Aguja de Ceniza',
  'maps.obsidian-court': 'Corte de Obsidiana',
  'maps.eclipse-rift': 'Grieta del Eclipse',
  'maps.final-horizon': 'Horizonte Final',

  'items.pokeball.name': 'Poké Ball',
  'items.old-rod.name': 'Caña Vieja',
  'items.old-rod.desc': 'Pesca acuáticos básicos (franjas hasta Nv.40).',
  'items.good-rod.name': 'Buena Caña',
  'items.good-rod.desc': 'Pesca acuáticos hasta franjas medias (Nv.150).',
  'items.super-rod.name': 'Super Caña',
  'items.super-rod.desc': 'Pesca acuáticos en cualquier franja.',
  'items.pokeball.desc': '1× tasa de captura.',
  'items.greatball.name': 'Great Ball',
  'items.greatball.desc': '2× tasa de captura.',
  'items.superball.name': 'Super Ball',
  'items.superball.desc': '3× tasa de captura.',
  'items.ultraball.name': 'Ultra Ball',
  'items.ultraball.desc': '4× tasa de captura.',
  'items.masterball.name': 'Master Ball',
  'items.masterball.desc': '100× tasa de captura. Siempre captura.',
  'items.potion.name': 'Poción',
  'items.potion.desc': 'Restaura el 30% del HP de un Pokémon.',
  'items.great-potion.name': 'Superpoción',
  'items.great-potion.desc': 'Restaura el 60% del HP de un Pokémon.',
  'items.ultra-potion.name': 'Hiperpoción',
  'items.ultra-potion.desc': 'Restaura el 80% del HP de un Pokémon.',
  'items.hyper-potion.name': 'Poción Máxima',
  'items.hyper-potion.desc': 'Restaura el 90% del HP de un Pokémon.',
  'items.full-restore.name': 'Restaurar Todo',
  'items.full-restore.desc': 'Restaura por completo el HP de un Pokémon.',
  'items.medicine.name': 'Antídoto',
  'items.medicine.desc': 'Cura el envenenamiento de un Pokémon.',
  'items.revive.name': 'Revivir',
  'items.revive.desc': 'Revive a un Pokémon debilitado.',
  'items.leaf-stone.name': 'Piedra Hoja',
  'items.leaf-stone.desc': 'Evoluciona Pokémon de tipo Planta.',
  'items.water-stone.name': 'Piedra Agua',
  'items.water-stone.desc': 'Evoluciona Pokémon de tipo Agua.',
  'items.thunder-stone.name': 'Piedra Trueno',
  'items.thunder-stone.desc': 'Evoluciona Pokémon de tipo Eléctrico.',
  'items.fire-stone.name': 'Piedra Fuego',
  'items.fire-stone.desc': 'Evoluciona Pokémon de tipo Fuego.',
  'items.sun-stone.name': 'Piedra Solar',
  'items.sun-stone.desc': 'Evoluciona Pokémon amantes del sol.',
  'items.moon-stone.name': 'Piedra Lunar',
  'items.moon-stone.desc': 'Referencia a la luna. Evoluciona a algunos Pokémon.',
  'items.ice-stone.name': 'Piedra Hielo',
  'items.ice-stone.desc': 'Evoluciona Pokémon de tipo Hielo.',
  'items.shiny-stone.name': 'Piedra Shiny',
  'items.shiny-stone.desc': 'Evoluciona Pokémon shiny.',
  'items.venom-stone.name': 'Piedra Veneno',
  'items.venom-stone.desc': 'Evoluciona Pokémon de tipo Veneno.',
  'items.rock-stone.name': 'Piedra Roca',
  'items.rock-stone.desc': 'Evoluciona Pokémon de tipo Roca.',
  'items.punch-stone.name': 'Piedra Puño',
  'items.punch-stone.desc': 'Evoluciona Pokémon de tipo Lucha.',
  'items.cocoon-stone.name': 'Piedra Capullo',
  'items.cocoon-stone.desc': 'Evoluciona Pokémon de capullo.',
  'items.crystal-stone.name': 'Piedra Cristal',
  'items.crystal-stone.desc': 'Evoluciona Pokémon de cristal.',
  'items.darkness-stone.name': 'Piedra Oscuridad',
  'items.darkness-stone.desc': 'Evoluciona Pokémon de tipo Siniestro.',
  'items.earth-stone.name': 'Piedra Tierra',
  'items.earth-stone.desc': 'Evoluciona Pokémon de tipo Tierra.',
  'items.enigma-stone.name': 'Piedra Enigma',
  'items.enigma-stone.desc': 'Evoluciona Pokémon de tipo Psíquico.',
  'items.heart-stone.name': 'Piedra Corazón',
  'items.heart-stone.desc': 'Evoluciona Pokémon de tipo Hada.',
  'items.drop-electric-box.name': 'Caja Eléctrica',
  'items.drop-essence-fire.name': 'Esencia de Fuego',
  'items.drop-water-gem.name': 'Gema de Agua',
  'items.drop-seed.name': 'Semilla',
  'items.drop-bug-antenna.name': 'Antena de Bicho',
  'items.drop-feather.name': 'Pluma',
  'items.drop-tooth.name': 'Diente',
  'items.drop-twisted-spoon.name': 'Cuchara Torcida',
  'items.drop-stone-orb.name': 'Orbe de Piedra',
  'items.drop-bone.name': 'Hueso',
  'items.drop-ghost-trace.name': 'Rastro Fantasma',
  'items.drop-dragon-tooth.name': 'Colmillo de Dragón',
  'items.drop-champion-belt.name': 'Cinturón de Campeón',
  'items.drop-poison-bottle.name': 'Botella de Veneno',
  'items.drop-fox-tail.name': 'Cola de Zorro',
  'items.drop-iron-pin.name': 'Pin de Hierro',
  'items.drop-ice-orb.name': 'Orbe de Hielo',
  'items.drop-luck-medal.name': 'Medalla de la Suerte',
  'toast.removeFromTeam': "Quita el Pokémon del equipo antes de vender.",
  'toast.nothingToSell': "Nada que vender.",
  'toast.sellStockMismatch': "Inventario desincronizado con el servidor. Cantidades actualizadas — intenta vender de nuevo.",
  'toast.noEligiblePokemon': "Ningún Pokémon elegible para vender.",
  'toast.unlockToSell': "Desbloquea el candado (sync) e intenta vender de nuevo.",
  'toast.sellPokemonBatch': "Demasiados Pokémon seleccionados. Inténtalo de nuevo — la venta va en lotes.",
  'toast.teamFull': "Tu equipo ya tiene seis Pokémon. Quita una reserva primero.",
  'toast.teamSyncFailed': "No se pudo guardar el equipo en el servidor.",
  'toast.cannotEvolveYet': "Este Pokémon aún no puede evolucionar.",
  'toast.evolutionUnavailable': "La evolución ya no está disponible.",
  'toast.stoneUnavailable': "Esa piedra no está disponible.",
  'team.movesPending': "Cambios pendientes",
  'team.movesSaved': "Movimientos guardados",
  'team.levelLabel': "Nivel {level}",
  'team.status': "STATS",
  'auto.potionStock': "{count} poción(es) disponible(s)",
  'auto.potionNone': "Ninguna poción en el inventario.",
  'battle.turnEnemy': "Turno enemigo",
  'battle.turnPlayer': "Tu turno",
  'map.unlockAt': "Se desbloquea en el nivel {level}",
  'map.routeUnlocked': "Ruta liberada",
  'log.soldFor': "vendido por {total} IdleCoin.",
  'log.soldCoins': "vendido · +{total} IdleCoin",
  'log.soldMany': "vendidos {count} · +{total} IdleCoin",
  'dialog.shop': "Tienda",
  'col.empty': "Aún no has capturado ningún Pokémon.<br>Activa la auto-captura y aventúrate en una ruta.",
  'col.noMatch': "Ningún Pokémon coincide con los filtros.<br>Ajusta o limpia los filtros de arriba.",
  'col.equip': "Equipar en el equipo",
  'col.unequip': "Quitar del equipo",
  'col.equippedToast': "¡{name} fue equipado en el equipo!",
  'col.removedToast': "{name} fue quitado del equipo.",
  'col.detailStatus': "Stats · Nv. {level}",
  'evo.titleName': "Evolucionar {name}",
  'sys.pixiOn': "Renderer PixiJS activo — Saffron en tiles.",
  'sys.pixiOff': "Pixi no disponible — usando PNG.",
  'sys.bootDegraded': "Parte de la carga falló. Recarga (F5) si algo deja de responder.",
  'sys.movesFail': "Movimientos: error al cargar datos.",
  'sys.updateAvailable': 'Hay una nueva versión — el juego se actualizará en breve.',
  'sys.updateNow': 'Actualizar ahora',
  'sys.collisionFail': "Colisión detallada de la ciudad no disponible.",
  'battle.goingTo': "{attacker} YENDO HACIA {target}",
  'battle.fightingWith': "{attacker} LUCHANDO CONTRA {target}",
  'battle.fallbackAttack': "Ataque",
  'battle.unaffected': "no afectó",
  'battle.superEffective': "¡Muy eficaz!",
  'battle.notEffective': "Poco eficaz...",
  'hunt.territory': "Territorio {type}",
  'hunt.levelPokemon': "Pokémon de nivel {level}",
  'team.equippedMoves': "MOVIMIENTOS EQUIPADOS",
  'team.makePrincipal': "Hacer que {name} sea el Pokémon principal",
  'team.equipAsPrincipal': "Equipar como principal",
  'team.principal': "PRINCIPAL",
  'team.promotedToast': "¡{name} ahora es tu Pokémon principal!",
  'team.movesHint': "Equipa hasta cuatro movimientos. En combate, el Pokémon usa automáticamente el mejor movimiento listo; los usados se recargan por turnos.",
  'moves.oneTurn': "1 turno",
  'moves.turns': "{count} turnos",
  'moves.alwaysReady': "Siempre disponible",
  'moves.ready': "LISTO",
  'moves.rechargeLabel': "Recarga: {turns}",
  'moves.rotationAria': "Movimientos equipados y recarga por turnos",
  'team.ivsTotal': "Total {value}",
  'col.resultsOf': "{filtered} de {total} Pokémon",
  'col.ivsTotal': "IVs · total {value}",
  'market.title': "Mercado Global",
  'market.subtitle': "Compra, vende y negocia con jugadores de todo el mundo.",
  'market.tab.buy': "Comprar",
  'market.tab.sell': "Publicar",
  'market.tab.mine': "Mis anuncios",
  'market.categories': "Categorías",
  'market.category.all': "Todos",
  'market.category.item': "Objetos",
  'market.category.stone': "Piedras",
  'market.category.ball': "Poké Balls",
  'market.category.loot': "Recursos",
  'market.category.pokemon': "Pokémon",
  'market.searchPlaceholder': "Buscar objeto o Pokémon...",
  'market.sort': "Ordenar",
  'market.sort.recent': "Más recientes",
  'market.sort.priceAsc': "Menor precio",
  'market.sort.priceDesc': "Mayor precio",
  'market.clear': "Limpiar",
  'market.cards': "Tarjetas",
  'market.rows': "Filas",
  'market.filters': "Filtros avanzados",
  'market.any': "Cualquiera",
  'market.filter.currency': "Moneda",
  'market.filter.ivMin': "IV mínimo",
  'market.filter.ivMax': "IV máximo",
  'market.filter.levelMin': "Nivel mínimo",
  'market.filter.levelMax': "Nivel máximo",
  'market.filter.type': "Tipo",
  'market.filter.rarity': "Rareza",
  'market.filter.shiny': "Solo Shiny",
  'market.currency': "Moneda",
  'market.currency.idlecoin': "IdleCoin",
  'market.currency.emerald': "Emerald",
  'market.item': "Objeto",
  'market.items': "Objetos · Poké Balls · Recursos",
  'market.pokemon': "Pokémon",
  'market.groupSummary': "{qty}× · {sellers} vendedores",
  'market.fromPrice': "desde {price} {currency}/u",
  'market.offerOnly': "Solo ofertas",
  'market.power': "Poder",
  'market.details': "Detalles del anuncio",
  'market.selectListing': "Selecciona un anuncio para ver sus detalles.",
  'market.level': "Nivel",
  'market.unitPrice': "Precio unitario",
  'market.quantity': "Cantidad",
  'market.total': "Total",
  'market.multipleSellers': "{count} vendedores disponibles",
  'market.seller': "Vendedor",
  'market.buyNow': "Comprar ahora",
  'market.makeOffer': "Ofertar",
  'market.showing': "Mostrando {start}–{end} de {total} resultados",
  'market.noResults': "No se encontraron anuncios",
  'market.noResultsHint': "Ajusta los filtros o prueba otra búsqueda.",
  'market.deliveriesReady': "{count} entrega(s) lista(s)",
  'market.claimNow': "Reclamar ahora",
  'market.deliveriesClaimed': "Entregas reclamadas en tu partida.",
  'market.sellTitle': "Publicar en el Mercado",
  'market.sellSubtitle': "Elige un recurso de tu partida o custodia y define las condiciones.",
  'market.localSave': "Partida local",
  'market.inCustody': "En custodia",
  'market.selectAsset': "Selecciona un objeto o Pokémon para publicar.",
  'market.listAsset': "Configurar anuncio",
  'market.onlyOffers': "Solo ofertas",
  'market.allowOffers': "Aceptar ofertas",
  'market.fee': "Tasa ({percent}%)",
  'market.custodyWarning': "El Pokémon queda en custodia, fuera del equipo y depósito, hasta venderse o cancelarse.",
  'market.depositWarning': "El recurso se moverá a la custodia segura antes del anuncio.",
  'market.listPokemon': "Publicar Pokémon",
  'market.listNow': "Publicar",
  'market.withdraw': "Retirar de custodia",
  'market.noItems': "No hay objetos elegibles.",
  'market.noPokemon': "No hay Pokémon elegibles.",
  'market.myListings': "Mis anuncios",
  'market.myListingsSubtitle': "Sigue el stock, precio y ofertas pendientes.",
  'market.noListings': "No tienes anuncios activos.",
  'market.pendingOffer': "En oferta",
  'market.active': "Activo",
  'market.cancel': "Cancelar",
  'market.secureCustody': "Custodia y liquidación protegidas por el servidor",
  'market.pulseActive': 'Activos',
  'market.pulseRequests': 'Pedidos',
  'market.pulseOffers': 'Ofertas',
  'market.pulseProtected': 'custodia protegida',
  'market.purchaseComplete': "Compra completada. La entrega está lista.",
  'market.listingCreated': "Anuncio creado.",
  'market.listingCancelled': "Anuncio cancelado y custodia devuelta.",
  'market.withdrawn': "Recurso devuelto a tu partida.",
  'market.error.generic': "No se pudo completar la operación del mercado.",
  'market.error.wallet_migration_required': "La cartera espera su migración inicial de IdleCoin.",
  'market.error.migration_amnesty_pending': "La migración espera la configuración del límite de amnistía.",
  'market.error.insufficient_market_balance': "Saldo insuficiente para esta compra.",
  'market.error.insufficient_listing_fee': "Saldo insuficiente para pagar la tasa del anuncio.",
  'market.error.item_deposit_cap_reached': "Se alcanzó el límite diario de depósito de este objeto.",
  'market.error.pokemon_deposit_cap_reached': "Se alcanzó el límite diario de esta rareza.",
  'market.error.pokemon_not_in_save': "Este Pokémon aún no está en tu guardado sincronizado. Espera unos segundos e inténtalo de nuevo.",
  'market.error.item_not_in_save': "Esta cantidad aún no está en tu guardado sincronizado. Espera unos segundos e inténtalo de nuevo.",
  'market.error.listing_not_buyable': "Este anuncio ya no está disponible.",
  'market.error.bulk_quantity_unavailable': "No hay cantidad suficiente dentro del precio elegido.",
  'market.error.delivery_not_claimable': "Esta entrega ya fue reclamada o no está disponible.",
  'market.tab.requests': "Solicitudes",
  'market.tab.offers': "Ofertas",
  'market.tab.history': "Historial",
  'market.tab.ignored': "Ignorados",
  'market.ignoreSeller': "Ignorar a este vendedor",
  'market.pokemonOnlyOffer': "Oferta en Pokémon",
  'market.offerFrom': "Recibida de {name}",
  'market.offerTo': "Enviada a {name}",
  'market.offerSummary': "{qty}× · {pokemon} Pokémon incluido(s)",
  'market.accept': "Aceptar",
  'market.reject': "Rechazar",
  'market.withdrawOffer': "Retirar oferta",
  'market.offersTitle': "Ofertas",
  'market.offersSubtitle': "El dinero y los Pokémon permanecen en escrow hasta la respuesta.",
  'market.received': "Recibidas",
  'market.sent': "Enviadas",
  'market.noReceivedOffers': "No hay ofertas recibidas.",
  'market.noSentOffers': "No hay ofertas enviadas.",
  'market.addPokemon': "Añadir Pokémon (opcional)",
  'market.noPokemonForOffer': "No hay Pokémon disponibles para ofrecer.",
  'market.offerEscrowWarning': "El saldo y los Pokémon ofrecidos quedan protegidos por el servidor.",
  'market.sendOffer': "Enviar oferta",
  'market.offerSent': "Oferta enviada.",
  'market.offerAccepted': "Oferta aceptada y liquidada.",
  'market.offerRejected': "Oferta rechazada y escrow devuelto.",
  'market.offerWithdrawn': "Oferta retirada y escrow devuelto.",
  'market.requestBy': "Solicitado por {name}",
  'market.requestQtyPrice': "{qty}× por {price} {currency}/u",
  'market.anyPokemon': "Sin filtros adicionales",
  'market.fulfill': "Atender",
  'market.myRequest': "Mi solicitud",
  'market.escrowActive': "Saldo en escrow",
  'market.requestsTitle': "Solicitudes",
  'market.requestsSubtitle': "Órdenes de compra financiadas que se atienden desde el inventario.",
  'market.searchRequests': "Buscar solicitudes...",
  'market.openRequests': "Solicitudes abiertas",
  'market.noRequests': "No hay solicitudes abiertas.",
  'market.myRequests': "Mis solicitudes",
  'market.noMyRequests': "No tienes solicitudes activas.",
  'market.createRequest': "Crear solicitud",
  'market.assetType': "Tipo de recurso",
  'market.itemSlug': "Código del objeto",
  'market.species': "Especie",
  'market.requestEscrowWarning': "El valor total queda en escrow y vuelve al cancelar o expirar.",
  'market.publishRequest': "Publicar solicitud",
  'market.fulfillRequest': "Atender solicitud",
  'market.noEligibleAsset': "No hay un recurso elegible en la partida o custodia.",
  'market.fulfillFor': "Atender por {price} {currency}",
  'market.requestPublished': "Solicitud publicada con saldo en escrow.",
  'market.requestFulfilled': "Solicitud atendida. Pago recibido.",
  'market.requestCancelled': "Solicitud cancelada y saldo devuelto.",
  'market.historyTitle': "Historial",
  'market.historySubtitle': "Compras, ventas y referencias recientes de precio.",
  'market.role.buyer': "Compra",
  'market.role.seller': "Venta",
  'market.noHistory': "No hay transacciones completadas.",
  'market.recentMedians': "Medianas de 30 días",
  'market.tradeCount': "{count} negocio(s)",
  'market.noMedians': "Todavía no hay datos suficientes.",
  'market.ignoredTitle': "Jugadores ignorados",
  'market.ignoredSubtitle': "Sus anuncios y solicitudes permanecen ocultos.",
  'market.unignore': "Dejar de ignorar",
  'market.noIgnored': "No ignoras a ningún jugador.",
  'market.ignored': "Jugador ignorado.",
  'market.unignored': "Jugador eliminado de ignorados.",
  'market.error.emptyOffer': "Incluye IdleCoin, Emerald o al menos un Pokémon.",
  'market.error.insufficient_offer_balance': "Saldo insuficiente para financiar esta oferta.",
  'market.error.insufficient_request_balance': "Saldo insuficiente para financiar esta solicitud.",
  'market.error.listing_not_offerable': "Este anuncio ya no acepta ofertas.",
  'market.error.offer_no_longer_settleable': "Esta oferta ya no puede liquidarse.",
  'market.error.request_not_fulfillable': "Esta solicitud ya no puede atenderse.",
  'market.searchAssets': "Buscar en inventario y custodia...",
  'market.searchPokemon': "Buscar Pokémon para ofrecer...",
  'market.error.market_rate_limit_exceeded': "Demasiadas operaciones seguidas. Espera un momento e inténtalo otra vez.",

  'tut.next': 'Siguiente',
  'tut.skip': 'Saltar tutorial',
  'tut.skipConfirm': '¿Saltar el tutorial? Puedes reabrirlo en Ajustes.',
  'tut.skipYes': 'Saltar',
  'tut.skipNo': 'Seguir',
  'tut.restart': 'Repasar tutorial',
  'tut.progress': '{current}/{total}',
  'tut.veteranToast': 'Tutorial disponible en Ajustes → Repasar tutorial.',
  'tut.welcome.title': 'Bienvenido a IdleMon',
  'tut.welcome.body': 'Un recorrido rápido por lo esencial. Puedes saltarlo cuando quieras.',
  'tut.cityWalk.title': 'Saffron City',
  'tut.cityWalk.body': 'Esta es la zona segura. Camina con W A S D y habla con los NPCs cuando lo necesites.',
  'tut.teamHud.title': 'Tu equipo',
  'tut.teamHud.body': 'Aquí está el equipo activo. El compañero principal lidera los combates automáticos.',
  'tut.partnerBars.title': 'PS y PE',
  'tut.partnerBars.body': 'La barra verde es la vida; la de abajo es la experiencia del Pokémon.',
  'tut.currency.title': 'IdleCoin y Emerald',
  'tut.currency.body': 'IdleCoin sale de combates y ventas. Emerald es la moneda premium.',
  'tut.openAtlas.title': 'Atlas de caza',
  'tut.openAtlas.body': 'Abre el Atlas para elegir dónde cazar.',
  'tut.pickRoute.title': "Elige el tipo",
  'tut.pickRoute.body': "Empieza por el tipo resaltado. Cada tipo tiene su propia lista de Pokémon.",
  'tut.pickLevelOne.title': "Elige el nivel 1",
  'tut.pickLevelOne.body': "Selecciona Nv. 1: es la franja segura para aprender cómo funciona la caza.",
  'tut.pickSpecies.title': "Elige el Pokémon",
  'tut.pickSpecies.body': "Ahora elige qué Pokémon de nivel 1 quieres buscar.",
  'tut.startHunt.title': "Inicia la caza",
  'tut.startHunt.body': "Todo está listo. Toca Cazar para viajar a la ruta elegida.",
  'tut.battleAuto.title': 'Combate automático',
  'tut.battleAuto.body': 'El juego caza solo. Observa el estado e interviene cuando quieras.',
  'tut.enemyHud.title': 'Pokémon salvaje',
  'tut.enemyHud.body': 'Nombre, tipo y PS del oponente aparecen aquí durante la pelea.',
  'tut.restButton.title': 'Descansar',
  'tut.restButton.body': 'Usa Descansar para armar recompensas offline cuando salgas del juego.',
'tut.capturePanel.title': "Panel de captura",
'tut.capturePanel.body': "Cuando un salvaje se debilita, aparece aquí. Elige una bola e intenta capturar.",
'tut.captureBall.title': "Lanza una bola",
'tut.captureBall.body': "Elige una bola arriba y toca Lanzar para intentar la captura.",
'tut.navCaptures.title': "Historial de capturas",
'tut.navCaptures.body': "Abre el registro de capturas recientes.",
'tut.navMyPokemon.title': "Mis Pokémon",
'tut.navMyPokemon.body': "Gestiona el equipo y mira el detalle de cada miembro.",
'tut.teamDetail.title': "Detalle del equipo",
'tut.teamDetail.body': "Aquí ves IVs, movimientos y promocionas reservas.",
'tut.navInventory.title': "Inventario",
'tut.navInventory.body': "Abre la mochila para ver bolas, pociones y botín.",
'tut.potions.title': "Pociones",
'tut.potions.body': "Usa pociones para recuperar PS del compañero en la cacería.",
'tut.navAutomation.title': "Automatización",
'tut.navAutomation.body': "Ajusta curación y captura automáticas.",
'tut.autoPotion.title': "Auto-poción",
'tut.autoPotion.body': "Actívala para curar solo cuando bajen los PS.",
'tut.autoCaptureVip.title': "Auto-captura (VIP)",
'tut.autoCaptureVip.body': "Capturar automáticamente tras el KO es un beneficio VIP. En el plan free usa las bolas del panel.",
'tut.healNurse.title': "Nurse Joy",
'tut.healNurse.body': "En la ciudad, Nurse Joy cura al equipo gratis.",
'tut.shopNpc.title': "Tienda de Sam",
'tut.shopNpc.body': "Abre la tienda para comprar suministros o vender botín.",
'tut.shopSell.title': "Vender drops",
'tut.shopSell.body': "En la pestaña Vender conviertes botín en IdleCoin.",
'tut.deposit.title': "Depósito",
'tut.deposit.body': "Guarda objetos y mueve Pokémon entre el equipo y el Box.",
'tut.depositBox.title': "Box",
'tut.depositBox.body': "Los Pokémon extra quedan en el Box hasta que los necesites.",
'tut.profile.title': "Perfil del entrenador",
'tut.profile.body': "Sigue nivel, prestigio y progreso.",
'tut.navSpecialization.title': "Especialización",
'tut.navSpecialization.body': "Invierte puntos de talento para reforzar tu estilo.",
'tut.specInvest.title': "Árboles de talento",
'tut.specInvest.body': "Cada árbol mejora un estilo. Obtienes el primer punto en el nivel 50.",
'tut.systemsDiscovery.title': "Sistemas",
'tut.systemsDiscovery.body': "Atajos a gimnasios, raids, crafting y más.",
'tut.navPokedex.title': "Pokédex",
'tut.navPokedex.body': "Consulta especies, rutas y lo que ya registraste.",
'tut.navSystems.title': "Hub de sistemas",
'tut.navSystems.body': "Abre el hub para mejoras y modos avanzados.",
'tut.hubUpgrades.title': "Mejoras",
'tut.hubUpgrades.body': "Bonificaciones permanentes que aceleran el progreso.",
'tut.navAltar.title': "Altar shiny",
'tut.navAltar.body': "Ofrece cartas shiny en el altar para bonos raros.",
'tut.navBreeding.title': "Breeding",
'tut.navBreeding.body': "Cruza Pokémon para huevos con mejores IVs.",
'tut.dailyGift.title': "Regalo diario",
'tut.dailyGift.body': "Entra cada día para mantener la racha de recompensas.",
'tut.gamePass.title': "Game Pass",
'tut.gamePass.body': "Pase de temporada con recompensas free y premium. Solo informativo — sin presión para comprar.",
'tut.market.title': "Mercado",
'tut.market.body': "Negocia con otros jugadores.",
'tut.chat.title': "Chat",
'tut.chat.body': "Habla con el mundo, comparte tips y muestra capturas.",
'tut.compareLab.title': "Laboratorio",
'tut.compareLab.body': "Compara dos Pokémon lado a lado.",
'tut.emeraldStore.title': "Tienda de Esmeraldas",
'tut.emeraldStore.body': "Emerald compra cosméticos e impulsos. Opcional — el core loop funciona sin eso.",
  'common.new': 'Nuevo',
};
